export default __webpack_public_path__ + "static/media/Rectangle 1045.180d616b.png";